function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.helpfulSt0{fill:#0597F2;}\n\t.helpfulSt1{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "helpfulSt0",
  cx: 256,
  cy: 256,
  r: 256
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "helpfulSt1",
  d: "M175.9,220.2h-46.9c-7.8,0-14.1,6.3-14.1,14.1v140.6c0,7.8,6.3,14.1,14.1,14.1h46.9c7.8,0,14.1-6.3,14.1-14.1 V234.3C190,226.5,183.7,220.2,175.9,220.2z M340,136.8c0,24.8-15.2,38.8-19.5,55.4h59.6c19.6,0,34.8,16.2,34.9,34 c0.1,10.5-4.4,21.8-11.4,28.8l-0.1,0.1c5.7,13.7,4.8,32.8-5.4,46.6c5.1,15.2-0.1,33.8-9.6,43.8c2.5,10.3,1.3,19.1-3.6,26.1 c-12,17.2-41.6,17.4-66.7,17.4h-1.6c-28.3,0-51.4-10.3-70.1-18.6c-9.4-4.2-21.6-9.3-30.9-9.5c-3.8-0.1-6.9-3.2-6.9-7V228.6 c0-1.9,0.8-3.7,2.1-5c23.2-22.9,33.2-47.2,52.2-66.3c8.7-8.7,11.8-21.8,14.9-34.5c2.6-10.8,8-33.9,19.9-33.9 C311.9,89,340,93.7,340,136.8z"
});

function SvgHelpfulActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpfulActive);
export default __webpack_public_path__ + "static/media/helpfulActive.2b532862.svg";
export { ForwardRef as ReactComponent };